import {
  shallowRef,
  computed,
} from 'vue';
import { defineStore } from 'pinia';

// import { $http } from '@/plugins/axios';
// import { useAuthStore } from '@/store/auth';
import { useLocaleStore } from '@/store/locale';
import { vueI18n } from '@/i18n';
import { purchasedProductsSummaryGet } from '@/api/billing';
import type { PurchasedProductsSummaryResult } from '@/api/billing';


export const useBillingStore = defineStore('billing', () => {
  // const authStore = useAuthStore();
  const localeStore = useLocaleStore();

  // const balance = shallowRef<number>();
  // function setBalance(value: typeof balance.value) {
  //   balance.value = value;
  // }

  // const balanceText = computed(() => {
  //   if (!balance.value) {
  //     return localeStore.noData;
  //   }
  //   return `${balance.value} ₽`;
  // });

  // let getBalanceAbortController = $http.eAbortController;
  // function getBalance() {
  //   getBalanceAbortController.abort();
  //   getBalanceAbortController = new AbortController();

  //   $http.get<{ balance: number }>(
  //     `users/users/${authStore.userId}/`,
  //     { signal: getBalanceAbortController.signal },
  //   )
  //     .then((response) => {
  //       if (response.config.signal !== getBalanceAbortController.signal) {
  //         throw undefined;
  //       }
  //       setBalance(response.data.balance);
  //     })
  //     .catch((error) => {
  //       if ($http.isCancel(error)) {
  //         return;
  //       }
  //       $http.showErrorMessage(error, vueI18n.t('common.stores.billing.getBalanceError'));
  //     });
  // }

  function onLogOut() {
    // balance.value = undefined;
    // getBalanceAbortController.abort();
    availableProcessings.value = undefined;
  }


  // Для получения количества доступных обработок
  const availableProcessingsLoading = shallowRef(false);
  // eslint-disable-next-line max-len
  const availableProcessings = shallowRef<PurchasedProductsSummaryResult['balance']['sample_processing_package']>();
  const hasAvailableProcessings = computed(() => Number(availableProcessings.value?.available) > 0);
  const availableProcessingsText = computed<string>(() => {
    if (availableProcessingsLoading.value) {
      return localeStore.loading;
    }
    if (!availableProcessings.value) {
      return '';
    }
    return vueI18n.t(
      'components.filePrice.available',
      [availableProcessings.value.available],
    );
  });
  function getAvailableProcessings() {
    if (availableProcessingsLoading.value) {
      return;
    }
    availableProcessingsLoading.value = true;
    purchasedProductsSummaryGet()
      .then((response) => {
        availableProcessings.value = response.data.balance.sample_processing_package;
      })
      .catch((error) => {
        purchasedProductsSummaryGet.http.showErrorMessage(
          error,
          vueI18n.t('Samples.ActionsForSelected.methods.calcAnalyzePriceError'),
        );
      })
      .finally(() => {
        availableProcessingsLoading.value = false;
      });
  }


  return {
    // balance,
    // setBalance,

    // balanceText,

    // getBalance,

    onLogOut,

    availableProcessingsLoading,
    hasAvailableProcessings,
    availableProcessingsText,
    getAvailableProcessings,
  };
});
